import { RefObject, useCallback, useMemo } from 'react';
import { slideHorizontalScroll } from '@futrli/shared-services';

const DEFAULT_PIXELS_TO_SCROLL = 500;
const DEFAULT_SCROLL_TIME = 500;

export enum UseScrollButtonsDirection {
  'back' = 'back',
  'forward' = 'forward'
}

const useScrollButtons = (
  ref1: RefObject<HTMLElement>,
  ref2?: RefObject<HTMLElement>,
  pixelsToScroll = DEFAULT_PIXELS_TO_SCROLL,
  scrollTime = DEFAULT_SCROLL_TIME
) => {
  const scroll = useCallback(
    (direction: UseScrollButtonsDirection) => {
      [ref1, ref2].forEach(ref => {
        const container = ref?.current;

        if (container) {
          const currentPosition = container.scrollLeft ?? 0;
          const targetPosition =
            direction === UseScrollButtonsDirection.back
              ? currentPosition - pixelsToScroll
              : currentPosition + pixelsToScroll;

          slideHorizontalScroll(container, targetPosition, scrollTime);
        }
      });
    },
    [pixelsToScroll, ref1, ref2, scrollTime]
  );

  const onScrollLeft = useCallback(() => scroll(UseScrollButtonsDirection.back), [scroll]);
  const onScrollRight = useCallback(() => scroll(UseScrollButtonsDirection.forward), [scroll]);

  return useMemo(() => ({ onScrollLeft, onScrollRight, scroll }), [onScrollLeft, onScrollRight, scroll]);
};

export default useScrollButtons;
